import {
    Dialog, DialogSurface, DialogTitle, DialogContent,
    DialogActions, DialogTrigger, DialogBody, Button, Image, makeStyles
} from "@fluentui/react-components";

function DeleteEventDialog(props) {

    const DeleteEvent = () => {
        props.DeleteEvent();
    }

    return (
        <Dialog
            open={props.isDeleteDialogOpen}
            onOpenChange={(event, data) => {
                props.setIsDeleteDialogOpen(data.open);
            }}
        >
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>Delete {props.text}</DialogTitle>
                    <DialogContent>
                        Are you sure you want to delete {props.text.toLowerCase()}?
                    </DialogContent>

                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">Close</Button>
                        </DialogTrigger>
                        <Button appearance="primary" onClick={DeleteEvent}>Delete</Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}

export default DeleteEventDialog